import { Lookup } from './lookup.interface';

export const Audiences: { [name: string]: Lookup } = {
  internalUsers: { displayValue: 'Internal users', code: 'internalUsers' },
  externalUsers: { displayValue: 'External users', code: 'externalUsers' },
  primeContractor: { displayValue: 'Prime contractor', code: 'primeContractor' },
};
